<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>     
    @import url('https://fonts.googleapis.com/css2?family=Kanit:wght@300&display=swap'); 
    body {
      font-family: 'Kanit', 'sans-serif';
    }
</style>
